<a [routerLink]="['/products', product.id]">
  <div class="relative flex justify-center overflow-hidden rounded">
    <img
      [src]="product.image | image"
      alt=""
      class="h-[180px] object-center"
      marketImageFailed />
    @if (product.salePrice) {
      <div
        class="absolute bottom-0 left-0 w-full bg-error/90 p-1 text-xs text-base-100">
        <div class="flex justify-between">
          <span class="text-sm">Flash Sale</span>
          <span>Còn {{ product.saleQuantity }} SP</span>
        </div>
        <p class="flex items-center justify-end gap-1">
          <span>Kết thúc</span>
          <market-count-down [endDate]="product.endDate"></market-count-down>
        </p>
      </div>
    }
  </div>
  <div class="bg-base-100 p-2">
    <h3 class="line-clamp-2 h-10 text-sm font-semibold text-slate-900">
      {{ product.name }}
    </h3>
    <div class="flex items-center justify-between">
      <p class="text-md font-semibold text-slate-600">
        @if (!product.salePrice) {
          <span class="text-error">{{ product.price | vnd }}</span>
        } @else {
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-lg text-error">
              {{ product.salePrice | vnd }}
            </span>
            <small class="text-sm text-gray-400 line-through">
              {{ product.price | vnd }}
            </small>
          </div>
        }
      </p>
    </div>
    <div class="flex flex-wrap items-center justify-between">
      <div class="flex items-center gap-1">
        <market-rating
          [ngModel]="product.rating"
          [style]="{ width: '12px', height: '12px' }" />
        <span>({{ product.rating }})</span>
      </div>
      <div class="flex gap-2" *ngxPermissionsExcept="guest">
        <button
          class="btn btn-primary btn-xs"
          (click)="cartButtonClickHandler($event)">
          <market-icon iconName="shopping-cart"></market-icon>
        </button>
        @if (editable) {
          <button
            class="btn btn-primary btn-xs"
            (click)="updateProductHandler($event)">
            <market-icon iconName="edit-3"></market-icon>
          </button>
        }
      </div>
    </div>
  </div>
</a>
